import { AuthConfig } from '../types/auth-config';
const RESOURCE_URL = process.env.REACT_APP_SSO_RESOURCE_URL || 'https://api.concretego.com/api';
const SSO_URL = process.env.REACT_APP_SSO_URL || 'https://dev.id.sysdyne.cloud';
const ACCOUNT_URL = process.env.REACT_APP_ACCOUNT_URL || 'https://dev.account.sysdyne.cloud';

export const authConfig: AuthConfig = {
  host: SSO_URL,
  clientId: 'cloudbatch',
  resource: RESOURCE_URL,
  scope: 'api',
  accountHost: ACCOUNT_URL,
  legacy: {
    // Legacy SSO URL – in our case it's the same as the new SSO URL
    host: SSO_URL,
  },
};
